module.exports = __webpack_public_path__ + "img/4_58.bb1a2039.png";